import React, { useRef, useState } from "react";
import { auth, db } from "../../firebase/config";
import { sendPasswordResetEmail, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useNavigate } from "react-router";
import style from "./Login.module.css";
import logo from "../../assets/logo.png";
import loginillustration from "../../assets/loginillustration.png";
import { CgProfile } from "react-icons/cg";
import { RiLockPasswordLine } from "react-icons/ri";
import { BsEye } from "react-icons/bs";
import { collection, getDocs, query, where } from "firebase/firestore";
import { toast } from "react-toastify";
const ResetPassword = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const pass = useRef();
  const submit = async (e) => {
    e.preventDefault();
    sendPasswordResetEmail(auth, email)
      .then(() => {
        // Password reset email sent!
        toast.success("تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى التحقق من البريد الوارد واتباع الخطوات لإعادة تعيين كلمة المرور.");
        navigate("/")
        // ..
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        toast.error("حدث خطأ أثناء إرسال رابط إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.");
        setError(true);
        // ..
      });
  };
  return (
    <div className={style.container}>
      <div className={style.rcircle}></div>
      <div className={style.nav}>
        <a href="https://archminaashraf.com/">
          <img src={logo} />
        </a>
        <div className={style.text}>
          <h2>مرحبا بك في خدمة شاتنا</h2>
          <p>
            من فضلك يرجي تسجيل الدخول حتي تتمكن من التحدث مع المهندسين الموسؤلة
            عن مشروعك
          </p>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none">
          <path
            d="M8.3335 20.5L31.6668 20.5M8.3335 20.5L18.3335 10.5M8.3335 20.5L18.3335 30.5"
            stroke="#999999"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div className={style.loginbody}>
        <form onSubmit={submit}>
          <div className={style.input}>
            <CgProfile size={25} color="#999" />
            <input
              type="text"
              placeholder="الايميل"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {error ? (
            <span style={{ color: "red" }}>The Email is wrong</span>
          ) : (
            ""
          )}
          <button type="submit"> استرجاع الايميل</button>
        </form>
        <div className={style.illustration}>
          <img src={loginillustration} width="100%" height="100%" />
        </div>
      </div>
      <div className={style.lcircle}></div>
    </div>
  );
};
export default ResetPassword;
